<template lang="pug">
  .next-button-container
    .skip-button(@click="handleSkipClick") 跳过
    .next-button(@click="handleNextClick")
      .next-button-text {{ text }}
</template>

<script>
import { debounce } from '@/utils/index';
import SPM from '../common/spm';

export default {
  name: 'NextButton',
  props: {
    // 按钮文本
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 按钮点击
    handleNextClick: debounce(function exec() {
      this.$emit('btnClick');
    }, 200),
    // 跳过点击
    handleSkipClick() {
      this.$emit('skipClick');
      // 跳过按钮点击埋点
      SPM.clickButton({
        buttonName: 'platform_XRJYDH_guanbi',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.next-button-container {
  display: flex;
  align-items: center;

  .skip-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.12rem;
    width: 0.76rem;
    height: 0.38rem;
    box-sizing: border-box;
    border-radius: 0.3rem;
    border: 0.01rem solid #fff;
    background-color: rgba(255, 255, 255, 0.2);
    color: #fff;
    line-height: normal;
    font-size: 0.16rem;
  }

  .next-button {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1.12rem;
    height: 0.38rem;
    background-image:
      linear-gradient(
        97.55deg,
        #ff8356 17.28%,
        #ff334b 51.38%,
        #f93a71 90.27%
      );
    border-radius: 0.3rem;

    .next-button-text {
      font-weight: 600;
      font-size: 0.18rem;
      line-height: normal;
      color: #fff;
    }
  }
}
</style>
